import { useAuthStore } from "../../stores/auth";
import { type TwinResponse } from "@shared/services/twinManagement";
import { type TicketManagementAuth } from "@shared/maintenance/hooks/maintenanceAuth";
import { clientId, roles } from "../constants";

export function useSFWAuth(): TicketManagementAuth {
  const authStore = useAuthStore();

  function isAdmin() {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.admin) ||
      false
    );
  }

  function isTicketTypeProcessor(_ticket: TwinResponse) {
    return isAdmin();
  }

  function isTicketTypeManager(_ticket: TwinResponse) {
    return isAdmin();
  }

  function isPlanner(_ticket: TwinResponse) {
    return isAdmin();
  }

  function isTicketCreator() {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.user) || false
    );
  }

  function isUser() {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.user) || false
    );
  }

  return {
    isAdmin,
    isTicketTypeManager,
    isTicketTypeProcessor,
    isPlanner,
    isTicketCreator,
    isUser,
  };
}
